import {
    all,
    call,
    cancel,
    delay,
    fork,
    put,
    select,
    take,
    takeLatest
} from "redux-saga/effects";
import config from "../../config";
import { http } from "../../common/lib";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post() {
    try {
        const { auditLocations } = yield select((state) => state);
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.assetSync,
            {
                auditAssets: [],
                auditLocations: auditLocations.data.map((item) => item.id)
            }
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On asset sync post:", { error });
        console.error(error);
        yield put(actionCreators.postFailure(error));
    }
}

function* watchTaskTick() {
    while (true) {
        yield delay(config.assetSync.timeout);
        yield put(actionCreators.postRequest());
    }
}

function* watch() {
    while (yield take(actionTypes.ASSET_SYNC_START)) {
        const workerTask = yield fork(watchTaskTick);
        yield take(actionTypes.ASSET_SYNC_STOP);
        yield cancel(workerTask);
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.ASSET_SYNC_POST_REQUEST, post), watch()]);
}
